import './styles/success-alert-bar.scss';
import React, {PropTypes} from 'react';
import AlertBarBase from './alert-bar-base';

export const SuccessAlertBar = props =>
    <div className='success-alert-bar'>
        <AlertBarBase
            alertTitle={props.alertTitle}
            dismissHandler={props.dismissHandler}
            iconClass='icon-checkmark'
            isDismissable={props.isDismissable}
            timeoutLength={props.timeoutLength}
            willAutoDismiss={props.willAutoDismiss}
        >
            {props.children}
        </AlertBarBase>
    </div>;

SuccessAlertBar.displayName = 'SuccessAlertBar';

SuccessAlertBar.propTypes = {
    alertTitle: PropTypes.any.isRequired,
    children: PropTypes.any.isRequired,
    dismissHandler: PropTypes.func.isRequired,
    isDismissable: PropTypes.bool,
    timeoutLength: PropTypes.number,
    willAutoDismiss: PropTypes.bool
};

SuccessAlertBar.defaultProps = {
    isDismissable: true,
    willAutoDismiss: true
};

export default SuccessAlertBar;



// WEBPACK FOOTER //
// ./src/shared/components/alert-bar/success-alert-bar.js